import { type CarWheelIdentifiers, TireSeason } from '@navio/nsdk';
import { type FilterOption } from 'noddi-ui-web';
import { CAR_WHEEL_IDENTIFIER_FILTER_OPTIONS } from '../../../features/CarWheel/carWheelIdentifiers';

export const WHEEL_SET_STORAGE_SEASON_FILTER_OPTIONS: FilterOption<TireSeason>[] = Object.values(TireSeason).map(
  (season) => ({
    value: season,
    label: season === TireSeason.ALL_SEASON ? 'All season' : season.charAt(0) + season.slice(1).toLowerCase()
  })
);

/** Wheel identifiers a recall car can have, with icons. Named for recalls: the shared constant is not exported. */
export const RECALL_CAR_WHEEL_IDENTIFIER_FILTER_OPTIONS: FilterOption<CarWheelIdentifiers>[] =
  CAR_WHEEL_IDENTIFIER_FILTER_OPTIONS;
